import { render, staticRenderFns } from "./dragableFilterBox.vue?vue&type=template&id=055f0c71&"
import script from "./dragableFilterBox.vue?vue&type=script&lang=js&"
export * from "./dragableFilterBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports